import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IUpdateSegmentedTrackingSettings {
  drivingSpeedThreshold: number;
  idleIntervalThresholdInMinutes: number;
  attribute_mileage_duration_to_job: boolean;
  attribute_to: string;
}

const updateSegmentedTrackingSettings = (postData: IUpdateSegmentedTrackingSettings) => {
  const newEndpoints = endpoints.companySettings.segmentedTracking;

  return http().post(newEndpoints, postData);
};

export function useUpdateSegmentedTrackingSettings() {
  return useMutation({ mutationFn: updateSegmentedTrackingSettings });
}
